import type { CopyShape } from "@tami/core/intl";

import type { PROPOSALS_SCRIPT_COPY_PT_BR } from "../proposals-script.copy";

export const PROPOSALS_SCRIPT_COPY_ES_ES: CopyShape<typeof PROPOSALS_SCRIPT_COPY_PT_BR> = {
  propIntro: {
    narrative: "Desde el lado de la Collab, poner precio no es una publi: es un presupuesto con varios creators dentro.",
  },
  propToolbar: {
    narrative: "Tus propuestas se quedan guardadas y reutilizables — la próxima marca empieza desde la anterior, no desde cero.",
    callout: "Busca, duplica y monta la siguiente propuesta en minutos.",
  },
  propOverview: {
    narrative: "Una propuesta por marca, con el pack entero de la cartera.",
  },
  propCards: {
    narrative: "Cada tarjeta muestra lo que paga la marca, cuánto queda de comisión y quién de la cartera entra en el pack.",
    callout: "Las fotos de abajo son los creators de la propuesta — tres, y el resto pasa a +N.",
  },
  propConverted: {
    narrative: "¿Cerrada? La propuesta se convierte en campaña con los creators y entregables ya rellenados.",
    callout: "La convertida queda marcada — no rehaces lo que ya es campaña.",
  },
};
